import List from "@/components/list";
/*
 *  超级管理员可以修改readony=1的数据，其他角色不可以，有新增权限才可以操作
 */

const Table = args => {
  const AccountTableConfig = [
    {
      label: "学习名称",
      prop: "name",
      minWidth: "200",
    },{
      label: "学习时长",
      prop: "pageStopTime",
      minWidth: "150",
    },{
      label: "学习时间",
      prop: "studyTimeStr",
      minWidth: "150",
    },{
      label: "学时",
      prop: "credit",
      minWidth: "110",
    }
  ];

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
